<template>
    <div class="home text-center">
        <img src="@/assets/images/tela-home.svg" alt="Seja bem-vindo" width="80%" height="auto"/>
    </div>
</template>

<script>
export default {
    name: 'Home',
    components: { },
    data: function() {
        return {
            stat: {}
        }
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style>
    .home {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
